import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { tap } from 'rxjs/operators'
import { Router } from '@angular/router'

import { AuthService } from './auth.service';
import { StorageService } from 'src/app/app.storage.service';
import { AppService } from 'src/app/app.service';
import { Constants } from 'src/app/app.constants';


@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  constructor(private router: Router,
    private auth: AuthService,
    private storageService: StorageService,
    private appService: AppService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //  alert("Hi")  
    if (req.headers.get('No-Auth') == "True") {
      return next.handle(req.clone());
    }

    
    if (this.auth.getAccessToken()) {
      let  count = 0;

      let switchUserId = this.storageService.getDataFromLocalStorage("switchUserId");

      let newAccount = this.storageService.getDataFromLocalStorage("newAccount")
      //  let headers = new HttpHeaders();
      let headers = req.headers;
      headers = headers.set("Authorization", this.auth.getAccessToken());
      
      if (switchUserId && !headers.has('userId')) {
        headers = headers.set("userId", switchUserId);
      } else if (headers.has('userId') && newAccount) {
        headers = headers.set("userId", headers.get("userId"))
      }
      // console.log(headers)
      //  if(switchUserId && !req.headers.has('userId')){
      //   headers = headers.append("userId",switchUserId);
      //  }else if(req.headers.has('userId') && newAccount){
      //    headers = headers.append("userId",req.headers.get("userId"))
      //  }

      const clonedreq = req.clone({
        headers: headers

      });
     
      //alert("clonedreq"+JSON.stringify(clonedreq))
      // const clonedreq = req.clone({
      //   // params: req.params.append("access_token", this.auth.getAccessToken())
      // });
    
      return next.handle(clonedreq)
        .pipe(tap(
          succ => {
           
              if (succ instanceof HttpResponse) {
                count  = 0;

              }
          

          },
          err => {
           
            if (err.status == Constants.HTTP_STATUS.UNAUTHORIZED) {
             // alert(JSON.stringify(err))
           
                let userData = this.storageService.getDataFromLocalStorage("userData");
                let expires_in = this.storageService.getDataFromLocalStorage("expires_in");
                let logged_time = this.storageService.getDataFromLocalStorage("logged_time");
                if (userData != null) {
                  let current_time =  Date.now()/1000 | 0;
                  if (userData.accessToken && userData.mmiId && (current_time - logged_time <= expires_in)) {
                    if(count<3){
                      count++;
                      this.appService.showInfoPopup("Message","Please Try Again.")
                    }else if(userData.refreshToken){
                    this.appService.refreshToken(userData.mmiId, userData.refreshToken)
                      .subscribe((res: HttpResponse<any>) => {
                        let user = res.body.user;
                        if (user.accessToken && user.refreshToken) {
                          this.storageService.setDataInLocalStorage("userData", user);
                          location.reload();
                        } else {
                          this.appService.showInfoPopup("Message","Not able to find refreshToken")
                          this.navigateToLogin();
                        }
                      }, (error) => {
                        this.appService.showInfoPopup("Message","refreshToken api fail")
                        this.navigateToLogin();
                      })
                    }
                  } else {
                    this.appService.showInfoPopup("Message","Not able to find accessToken")
                    this.navigateToLogin();
                  }
                } else {
                  this.appService.showInfoPopup("Message","Not able to find userData")
                  this.navigateToLogin();
                }
              
              
            }

          })
        );
    } else {
      // return next.handle(req.clone());
      // this.router.navigateByUrl('/unauth');
      this.navigateToLogin()
    }
  }

  navigateToLogin() {
    this.storageService.clearStorage();
    // this.router.navigate(['login']);
    window.location.href = Constants.LOGIN_URL;
  }

}
